export default function coverTable() {
    let tables = document.querySelectorAll('table');
    for (let i = tables.length - 1; i >= 0; i--) {
        if (!tables[i].classList.contains('bonus-list')) {
            let cover = document.createElement('div');
            cover.classList.add('cover-table');
            tables[i].parentNode.insertBefore(cover, tables[i]);
            cover.appendChild(tables[i]);
        }
    }
}
